<div class="bp-pill" [class.active]="isActive" (click)="onClick.emit()" (keydown.enter)="onClick.emit()">
	<span class="white-space-nowrap">
		<ng-content></ng-content>
	</span>
</div>
